"use strict";var e=require("react");exports.useStatus=(t,s,u)=>{const[r,c]=e.useState(null!=t?t:void 0);return e.useEffect((()=>{r!==t&&u&&u(r)}),[r]),e.useEffect((()=>{t&&t!==r&&c(t)}),[t,s]),[r,c]};
